import { ENV_CONFIG } from 'config/environment';
import { SCAM_PAC_CARDS } from './constants';

export const OurGoal = () => {
  return (
    <div className="our-goal-container">
      <div className="our-goal-top-content">
        <div className="our-goal-content-left">
          <span className="h2-dtm">Scam PACs hurt all of us</span>
          <span className="h4-text">
            Scam PACs are political action committees that raise money under the pretense of winning
            elections but spend hardly any of the money in ways that help us win. They siphon money
            away from legitimate organizations, erode trust with donors, and flood us all with spam.
          </span>
          <span className="h4-text">We can stop them with smarter tools and habits.</span>
        </div>
        <div className="our-goal-content-right">
          <img
            src={`${ENV_CONFIG.CLOUD_STORAGE.URL}/scampac/grift-alert.png`}
            alt="Grift alert"
            className="grift-alert-image"
          />
        </div>
      </div>
      <div className="our-goal-bottom-content">
        <span className="h2-dtm">What is a Scam PAC?</span>
        <div className="our-goal-cards">
          {SCAM_PAC_CARDS.map(({ number, color, title, text }) => (
            <div key={number} className="our-goal-card">
              <div className={`our-goal-card-number our-goal-card-number--${color}`}>{number}</div>
              <span className="our-goal-card-title">{title}</span>
              <span className="h4-text">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
